"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "40", height: "40", viewBox: "0 0 40 40", className: "Icon cross-large", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("circle", { fill: "#E60B0B", cx: "20", cy: "20", r: "20" }),
            _react2.default.createElement(
                "g",
                { fill: "#FFF" },
                _react2.default.createElement("path", { d: "M26.586 10.586l-16 16 2.828 2.828 16-16z" }),
                _react2.default.createElement("path", { d: "M26.586 29.414l2.828-2.828-16-16-2.828 2.828z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/cross-large.js
// module id = 1791
// module chunks = 0